export const WidgetNames = Object.freeze({
    DOCUMENTS: "Documents",
    AVERAGE_SCORE: "Average Score",
    NUMBER_METADATA_BREAKDOWN: "Number Metadata Breakdown",
    QUALITATIVE_METADATA_BREAKDOWN: "Qualitative Metadata Breakdown",
    VOLUME: "Volume",
    LARGEST_CONCEPT_MOVEMENT: "Largest Concept Movement",
    VOLUME_OVER_TIME: "Volume Over Time",
    SHARE_OF_VOICE_OVER_TIME: "Share of Voice Over Time",
    SHARE_OF_VOICE_OVER_TIME_BUBBLE: "Share of Voice Over Time - Bubble",
    LARGEST_NET_SENTIMENT_MOVEMENT: "Largest Net Sentiment Movement",
    SENTIMENT_OVER_TIME_LINE: "Sentiment Over Time Line",
    OVERALL_SENTIMENT: "Overall Sentiment",
    SENTIMENT_SHARE: "Sentiment Share",
    DRIVERS: "Drivers",
    DRIVERS_OVER_TIME: "Drivers Over Time",
    DRIVERS_DIFFERENCE_FROM_AVERAGE: "Drivers Difference from Average",
    IMPACT_SCORE: "Impact Score",
    OUTLIER_PERCENTAGE: "Outlier Percentage",
    LARGEST_SENTIMENT_MOVEMENT: "Largest Sentiment Movement",
    SENTIMENT_SHARE_BAR_CHART: "Sentiment Share Bar Chart",
    SENTIMENT: "Sentiment",
    NET_SENTIMENT_FOR_CONCEPT_OVER_TIME: "Net Sentiment for Concept over time",
    AVERAGE_SCORE_OVERTIME: "Average Score over time",
    METADATA_SHARE_OF_VOICE_OVER_TIME: "Metadata Share of Voice over Time",
    TEXT_WIDGET: "Text widget",
    METADATA_CONCEPT_VOLUME: "Metadata Concept Volume",
    METADATA_SENTIMENT_BREAKDOWN: "Metadata Sentiment Breakdown",
    METADATA_DRIVERS_BREAKDOWN: "Metadata Drivers Breakdown",
    NPS_BREAKDOWN: "NPS Breakdown",
    NPS_SCORE: "NPS Score",
    NPS_SCORE_OVERTIME: "NPS Score over time",
    LARGEST_DRIVERS_MOVEMENT: "Largest Drivers movement",
});

export const NewWidgetNames = Object.freeze({
    TEXT_WIDGET: "Text widget",
    TEXT_BOX: "Text Box",
    PROJECT: "Project",
    DOCUMENTS: "Documents",
    AVERAGE_SCORE: "Average Score",
    AVERAGE_SCORE_OVERTIME: "Average Score over time",
    NUMBER_METADATA_BREAKDOWN: "Number Metadata Breakdown",
    NPS_BREAKDOWN: "NPS Breakdown",
    NPS_SCORE: "NPS Score",
    NPS_SCORE_OVERTIME: "NPS Score over time",
    QUALITATIVE_METADATA_BREAKDOWN: "Qualitative Metadata Breakdown",
    METADATA_SHARE_OF_VOICE_OVER_TIME: "Metadata Share of Voice over Time",
    METADATA_CONCEPT_VOLUME: "Metadata Concept Volume",
    METADATA_SENTIMENT_BREAKDOWN: "Metadata Sentiment Breakdown",
    METADATA_DRIVERS_BREAKDOWN: "Metadata Drivers Breakdown",
    VOLUME: "Volume",
    LARGEST_CONCEPT_MOVEMENT: "Largest Concept Movement",
    VOLUME_OVER_TIME: "Volume Over Time",
    SHARE_OF_VOICE_OVER_TIME: "Share of Voice Over Time",
    SHARE_OF_VOICE_OVER_TIME_BUBBLE: "Share of Voice Over Time - Bubble",
    SENTIMENT: "Sentiment",
    LARGEST_NET_SENTIMENT_MOVEMENT: "Largest Net Sentiment Movement",
    SENTIMENT_OVER_TIME_LINE: "Sentiment Over Time Line",
    OVERALL_SENTIMENT: "Overall Sentiment",
    SENTIMENT_SHARE: "Sentiment Share",
    DRIVERS: "Drivers",
    DRIVERS_OVER_TIME: "Drivers Over Time",
    LARGEST_DRIVERS_MOVEMENT: "Largest Drivers movement",
    DRIVERS_DIFFERENCE_FROM_AVERAGE: "Drivers Difference from Average",
    IMPACT_SCORE: "Impact Score",
    WHATS_NEW: "What's New",
    OUTLIER_PERCENTAGE: "Outlier Percentage",
});
